
import PropTypes from 'prop-types'
import React from 'react'
import './BulletList.css'

const BulletList = props => (
  <ul className='BulletList' data-type={props.type || 'bullet'}>{props.children}</ul>
)

BulletList.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ]).isRequired,
  type: PropTypes.string
}

BulletList.displayName = 'BulletList'

export default BulletList



// WEBPACK FOOTER //
// ./ui/BulletList.js